import {
  Onboarding,
  OnboardingInfoButton,
} from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/Onboarding/Onboarding'
import Provider from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/Onboarding/Provider'

export const OnboardingPenetapan = {
  Provider,
  Onboarding,
  OnboardingInfoButton,
}
